[
  {
    "code": "PY-16",
    "name": "Alto Paraguay"
  },
  {
    "code": "PY-10",
    "name": "Alto Paraná"
  },
  {
    "code": "PY-13",
    "name": "Amambay"
  },
  {
    "code": "PY-ASU",
    "name": "Asunción"
  },
  {
    "code": "PY-19",
    "name": "Boquerón"
  },
  {
    "code": "PY-5",
    "name": "Caaguazú"
  },
  {
    "code": "PY-6",
    "name": "Caazapá"
  },
  {
    "code": "PY-14",
    "name": "Canindeyú"
  },
  {
    "code": "PY-11",
    "name": "Central"
  },
  {
    "code": "PY-1",
    "name": "Concepción"
  },
  {
    "code": "PY-3",
    "name": "Cordillera"
  },
  {
    "code": "PY-4",
    "name": "Guairá"
  },
  {
    "code": "PY-7",
    "name": "Itapúa"
  },
  {
    "code": "PY-8",
    "name": "Misiones"
  },
  {
    "code": "PY-9",
    "name": "Paraguarí"
  },
  {
    "code": "PY-15",
    "name": "Presidente Hayes"
  },
  {
    "code": "PY-2",
    "name": "San Pedro"
  },
  {
    "code": "PY-12",
    "name": "Ñeembucú"
  }
]